import { render, staticRenderFns } from "./flowLayout.vue?vue&type=template&id=6d23f186&scoped=true"
import script from "./flowLayout.vue?vue&type=script&lang=js"
export * from "./flowLayout.vue?vue&type=script&lang=js"
import style0 from "./flowLayout.vue?vue&type=style&index=0&id=6d23f186&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23f186",
  null
  
)

export default component.exports